import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.1221 5.65039C15.6667 5.65039 17.6836 7.62263 17.6836 10C17.6836 12.3774 15.6667 14.3496 13.1221 14.3496C10.5775 14.3495 8.56152 12.3773 8.56152 10C8.56152 7.62269 10.5775 5.65048 13.1221 5.65039Z",
  stroke: "currentColor",
  "stroke-width": "1.3",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.91106 14.9017C7.57707 14.9662 7.23152 15 6.87774 15C3.99972 15 1.66663 12.7614 1.66663 10C1.66663 7.23858 3.99972 5 6.87774 5C7.23152 5 7.57707 5.03383 7.91106 5.09829",
  stroke: "currentColor",
  "stroke-width": "1.3",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }